import React from 'react';
import { AlertCircle, ArrowUp, Minus } from 'lucide-react';
import '../../styles/admin/production/PriorityBadge.css';

const PriorityBadge = ({ priority }) => {
  const priorityConfig = {
    low: { label: 'Basse', className: 'priority-low', icon: <Minus size={12} /> },
    normal: { label: 'Normale', className: 'priority-normal', icon: null },
    high: { label: 'Haute', className: 'priority-high', icon: <ArrowUp size={12} /> },
    urgent: { label: 'Urgente', className: 'priority-urgent', icon: <AlertCircle size={12} /> }
  };

  const config = priorityConfig[priority] || priorityConfig.normal;

  return (
    <span className={`priority-badge ${config.className}`}>
      {config.icon}
      <span>{config.label}</span>
    </span>
  );
};

export default PriorityBadge;